<div
  class="pia-questionBlock"
  [ngClass]="{ approved: evaluation.status === 2 || evaluation.status === 3 }"
  [attr.data-id]="question.id"
>
  <div
    [innerHTML]="question.title | translate"
    class="pia-questionBlock-title"
  ></div>
  <button
    class="pia-icons pia-accordion pia-icon-accordion-up"
    type="button"
    (click)="displayQuestion($event)"
    title="{{ 'misc.display' | translate }}"
  ></button>
  @if (!loading) {
  <div class="pia-questionBlock-displayer fadeIn">
    <form [formGroup]="questionForm">
      <!-- Gauge -->
      @if (question.answer_type == 'gauge') {
      <div class="pia-gaugeBlock">
        <input
          type="range"
          (change)="checkGaugeChanges($event)"
          formControlName="gauge"
          min="0"
          max="4"
          step="1"
        />
        <div>
          <div>{{ "questions.gauges.0" | translate }}</div>
          <div>{{ "questions.gauges.1" | translate }}</div>
          <div>{{ "questions.gauges.2" | translate }}</div>
          <div>{{ "questions.gauges.3" | translate }}</div>
          <div>{{ "questions.gauges.4" | translate }}</div>
        </div>
        <div
          class="pia-gaugeBlock-background {{
            gaugeValue !== null && gaugeValue !== undefined
              ? 'pia-gaugeBlock-background-' + gaugeValue
              : ''
          }}"
        ></div>
      </div>
      }
      <!-- Tags list -->
      <div class="pia-questionBlock-content">
        @if (!isInputDisabled()) { @if (question.answer_type == 'list') {
        <tag-input
          (onAdd)="onAdd($event)"
          (onTagEdited)="onTagEdited($event)"
          (onRemove)="onRemove($event)"
          formControlName="list"
          [clearOnBlur]="true"
          [theme]="'foundation-theme'"
          [placeholder]="question.placeholder | translate"
          [disable]="isInputDisabled()"
          [onlyFromAutocomplete]="question.is_measure"
          (focusin)="questionContentFocusIn()"
          [secondaryPlaceholder]="question.placeholder | translate"
        >
          <tag-input-dropdown
            [showDropdownIfEmpty]="true"
            [autocompleteItems]="getAutocompleteItems()"
          ></tag-input-dropdown>
        </tag-input>
        } } @else {
        <ul class="pia-listBlock">
          @for (item of questionForm.controls.list.value; track item) {
          <li class="pia-listItem">
            {{ item }}
          </li>
          }
        </ul>
        }
        <!-- Question answer -->
        <div
          (click)="questionContentFocusIn()"
          class="pia-questionBlock-contentText"
          [innerHTML]="questionForm.controls['text']?.value | safeHtml"
          [ngClass]="{ hide: editor || !questionForm.controls['text']?.value }"
        ></div>
        @if ( (question.answer_type == 'text' || question.answer_type ==
        'gauge') && (editMode.includes('author') || editMode === 'local') ) {
        <textarea
          [attr.data-id]="question.id"
          id="pia-question-content-{{ question.id }}"
          formControlName="text"
          name="pia-question"
          rows="8"
          cols="50"
          [ngClass]="{ hide: hideTextarea }"
          (focusin)="questionContentFocusIn()"
          placeholder="{{ question.placeholder | translate }}"
        >
        </textarea>
        }
      </div>
    </form>
  </div>
  } @else {
  <div class="pia-sectionBlock-body" style="position:relative; height: 150px;">
    <app-loading-overlay
      [visibility]="true"
      [childMode]="true"
    ></app-loading-overlay>
  </div>
  } @if (answer && answer.id) {
  <app-comments
    [editMode]="editMode"
    [pia]="pia"
    [question]="question"
    [questionId]="question.id"
    [answer]="answer"
  >
  </app-comments>
  } @if (item.evaluation_mode === 'question') {
  <app-evaluations
    [editMode]="editMode"
    (evaluationEvent)="evaluationChange($event)"
    [pia]="pia"
    [section]="section"
    [item]="item"
    [questionId]="question.id"
  ></app-evaluations>
  }
</div>
